import { convertDateToMomentDateObjAtMidnightInSellerTimeZone } from '../services/datetime-service';

// This section of code contains the business logic for adjusting the Fulfillment Plan Date
// to meet the format required by the API.
export const convertUserRequestedDate = (date, sellerTimeZone) => {
  const convertedDate = convertDateToMomentDateObjAtMidnightInSellerTimeZone(date, sellerTimeZone);
  return convertedDate.toISOString();
};
